<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      show-save-button
      unit="内容"
      edit-title
      id-key="ContentId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属栏目" prop="ColumnName" label-width="120px">
              <select-input
                placeholder="选择栏目"
                :label="data.ColumnName"
                v-model="data.ColumnId"
                @click="openColumnDialog"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标题" prop="Title" label-width="120px">
              <el-input
                v-model="data.Title"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="展示图片" prop="PictureUrl" :class="data.IsRecommend?'is-required':''"  label-width="120px">
              <single-pic-upload
                v-model="data.PictureUrl"
                type="PictureUrl"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简介" prop="Intro"  label-width="120px">
              <el-input
                  v-model="data.Intro"
                  placeholder="请输入简介"
                ></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="Detail" label-width="120px">
              <editor v-model="data.Detail"></editor>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" label-width="120px">
              <upload-file-list :file-list="pAttachments" @success="onSuccess" @delete="onDelete" key-name="FileUrl" upload-url="/api/Content/UploadAttachment"></upload-file-list>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="外部链接" prop="ExternalLink"  label-width="120px">
              <el-input
                v-model="data.ExternalLink"
                placeholder="请输入外部链接"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="SEO标题" prop="SeoTitle"  label-width="120px">
              <el-input
                v-model="data.SeoTitle"
                placeholder="请输入SEO标题"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="SEO关键词" prop="SeoKeyword"  label-width="120px">
              <el-input 
                v-model="data.SeoKeyword"
                placeholder="请输入SEO关键词"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="SEO描述" prop="SeoDescription"  label-width="120px">
              <el-input
                v-model="data.SeoDescription"
                placeholder="请输入SEO描述"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="24">
            <el-form-item label="静态名称" prop="StaticName"  label-width="120px">
              <el-input
                v-model="data.StaticName"
                placeholder="请输入静态名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标签" prop="Tag"  label-width="120px">
              <el-input
                v-model="data.Tag"
                placeholder="请输入标签"
              ></el-input>
              <el-tag style="margin-top:5px">多个标签用 | 分隔</el-tag>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="信息来源" prop="Source"  label-width="120px">
              <el-input
                v-model="data.Source"
                placeholder="请输入信息来源"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="24">
            <el-form-item label="发布人" prop="Publisher" label-width="120px">
              <el-input
                v-model="data.Publisher"
                placeholder="请输入发布人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布时间" prop="PublishTime" label-width="120px">
              <el-date-picker
                size="mini"
                v-model.trim="data.PublishTime"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="访问量" prop="ViewCount" label-width="120px">
             <el-input-number v-model="data.ViewCount" :min="1" label="访问量"></el-input-number>       
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="前台显示" prop="IsShow" label-width="120px">
              <el-switch
                v-model="data.IsShow"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="热门" prop="IsRecommend" label-width="120px">
              <el-switch
                v-model="data.IsRecommend"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="置顶" prop="IsTop" label-width="120px">
              <el-switch
                v-model="data.IsTop"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <column-dialog
      ref="columnDialog"
      title="选择所属栏目"
      @select="setColumnId"
      :isAll="false"
    ></column-dialog>
  </div>
</template>
<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import uploadFileList from "@/components/common/files/uploadFileList";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import columnDialog from "@/components/website/column/listDialog";
import selectInput from "@/components/common/selectInput";
import singlePicUpload from "@/components/common/photo/singleUpload";
import Editor  from '@/components/common/editor.vue';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    columnDialog,
    selectInput,
    singlePicUpload,
    uploadFileList,
    Editor
  },
  data() {
    return {
      data: {
        ContentId:0,
        Title:"",
        ColumnId:"",
        ColumnName:"",
        PictureUrl:"",
        Intro:"",
        Detail:"",
        DetailText:"",
        ExternalLink:"",
        SeoTitle:"",
        SeoKeyword:"",
        SeoDescription:"",
        Tag:"",
        StaticName:"",
        Publisher: loginInfo.UserName,
        PublishTime: this.$commonJs.getToday(),
        Source:"",
        IsTop: false,
        IsRecommend: false,
        IsShow: true,
        ViewCount:0,
        Attachments: [],
      },
      api: require("@/api/website/content/content").default,
      pAttachments: [],
      delAttachmentsList: [],
      rules: {
        ColumnName:[{ required: true, message: "所属栏目不能为空" }],
        Title:[{ required: true, message: "标题不能为空" }],
        Detail: [{ required: true, message: "内容不能为空" }],
        Publisher: [{ required: true, message: "发布人不能为空" }],
        PublishTime: [{ required: true, message: "发布时间不能为空" }],
      },
      uploadUrl:"/api/content/uploadPicture",
    };
  },
  computed: {},
  mounted(){

  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {
      data.Attachments.forEach(e => {
        delete e.T;
        this.pAttachments.push(e);
      })
    },
    openColumnDialog() {
      this.$refs.columnDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    //上传成功回调
    onSuccess(res) {
      var data = res.Data;
      this.pAttachments.push({
        Extension: data.Extension,
        FileName: data.FileName,
        FilePath: data.FilePath,
        Msg: data.Msg,
        FileUrl: data.FileUrl,
        T: 0,
      });
    },
    //删除回调
    onDelete(index) {
      if(!(this.pAttachments[index]["T"] === 0)) {
        this.pAttachments[index]["T"] = 2;
        this.delAttachmentsList.push(this.pAttachments[index]);
      }
      this.pAttachments.splice(index, 1);
    },
    onBeforeSave() {
      if(this.data.IsRecommend && this.data.PictureUrl == "") {
        this.$message.error("推荐时，需上传展示图片")
        return false;
      }

      var to = this.pAttachments.filter(x => x.T===0||x.T===1);
      this.data.Attachments = to.concat(this.delAttachmentsList);
    },
    setColumnId(parent) {
      this.data.ColumnId = parent.ColumnId;
      this.data.ColumnName = parent.ColumnName;
    },
    onClosed() {
      this.pAttachments = [];
      this.delAttachmentsList = [];
    },
  },
};
</script>